
import * as Yup from "yup";
import CategoryModel from "../../models/masters/category-model";
import { API_END_POINT } from "../../constants";
import { InputField } from "../../components/form/input.field.component";
import { FormikModelDialog, SubmitStatus } from "../../core/formik-model-dialog.component";
import { CheckboxField, CheckBoxStyle } from "../../core/checkbox-field.component";
import { useEffect, useState } from "react";
import { useGetCategories } from "../../apiclient/master/useGetCategoryApi";

interface CategoryEditProps {
  data: CategoryModel;
  isViewMode?: boolean; // 
  onClose?: (status: SubmitStatus, data: any) => any;
}

const CategoryEntry: React.FC<CategoryEditProps> = ({ ...props }) => {
  let { data,  onClose,isViewMode } = props;
  const title = data?.categoryId > 0 ? "Edit Category" : "Add Category";
  
  let initialValue: CategoryModel = {
    id: data?.id ? data.id : 0,
    categoryId: data?.categoryId? data.categoryId:0,
    code: data?.code,
    name: data?.name,
    shortName: data?.shortName,
    displayOrder: data?.displayOrder,
    financeCode: data?.financeCode,
    isActive: data?.categoryId > 0 ? data.isActive : true,
    isAllowCredit: data?.isAllowCredit,
    isCommission: data?.isCommission,
    isSpecialOrder: data?.isSpecialOrder
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string()
    .required("Required")
    .test("check-duplicate-name", "Category name already exists", (value) => {
      // Ensure the value is compared in a case-insensitive manner
      return (
        value &&
        !existingName.some(existing => existing.toLowerCase() === value.toLowerCase()) ||
        (data?.name && value === data.name) // Allow current name during update
      );
    }), 

    shortName: Yup.string()
    .required("Required")
    .length(3, "Short Name must be exactly 3 characters")
    .test("check-duplicate-shortName", "Short Name already exists", (value) => {
      return (
        value &&
        (!existingShortName.some(
          (existing) =>
            existing && value.toLowerCase() === existing.toLowerCase()
        ) || (data?.shortName && value === data.shortName))
      );
    }),

    code: Yup.string()
      .required("Required")
      .test("check-duplicate-code", "Code already exists", (value) => {
        return (
          value &&
          !existingCode.includes(value) ||
          (data?.code && value === data.code) // Allow current code during update
        );
      }),
                     
  
  });


  const [existingName, setExistingName] = useState<string[]>([]);
  const [existingShortName, setExistingShortName] = useState<string[]>([]);


  const [existingCode, setExistingCode] = useState<string[]>([]);
  const { data: fetchedCategory } = useGetCategories();

  useEffect(() => {   

    if (fetchedCategory) {
      setExistingCode(fetchedCategory.map((cat: any) => cat.code));
      setExistingName(fetchedCategory.map((cat: any) => cat.name));
      setExistingShortName(
        fetchedCategory.map((cat: any) => cat.shortName).filter((val) => !!val)
      );
  }
}, [fetchedCategory]);  


return (
    <>
      <FormikModelDialog
        width="70%"
        title={title}
        initialData={initialValue}
        validationSchema={validationSchema}
        show={!!data}
        onClose={onClose}
        endpoint={API_END_POINT.MASTER}
        postRoute="Category/SaveCategory"
        showAddAnother={true}
        isViewOnly ={isViewMode}
        isUpDateEntityDetails={data?.categoryId>0? true: false}
      >
        <div>
          <div className="row">
            <div className="col-2">
              <InputField maxLength={10} label="Code *" name="code" />
            </div>
            <div className="col-6">
              <InputField maxLength={100} label="Category *" name="name" />
            </div>
            <div className="col-6">
              <InputField
                maxLength={3}
                label="Short Name"
                name="shortName"
              />
            </div>
            <div className="col-6">
              <div className="row col-12">
                <div className="col-4">
                  <InputField
                    maxLength={6}
                    label="Display Order"
                    name="displayOrder"
                  />
                </div>
                <div className="col-4">
                  <InputField
                    maxLength={6}
                    label="Finance Code"
                    name="financeCode"
                  />
                </div>
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-3">
                  <CheckboxField label="Allow Credit?" name="isAllowCredit" 
                    checkstyle={CheckBoxStyle.Normal}
                  />
              </div>
              <div className="col-3">
                  <CheckboxField
                    label="Allow Commission?"
                    name="isCommission"
                    checkstyle={CheckBoxStyle.Normal}
                  />
              </div>
              <div className="col-3">
                  <CheckboxField 
                    label="Allow Special Order?"
                    name="isSpecialOrder"
                    checkstyle={CheckBoxStyle.Normal}
                  />
              </div>
              <div className="col-3">
                  <CheckboxField  isChecked={true} label="Is Active?" name="isActive"  checkstyle={CheckBoxStyle.Normal} />
              </div>
            </div>
          </div>
        </div>
      </FormikModelDialog>
    </>
  );
};

export default CategoryEntry;
